import React, { FunctionComponent, useState } from 'react';
import { Origin } from '@upstart/harmony/lib/constants';
import { Car } from '@upstart/harmony/lib/legos/carTypes';
import { Deal } from '@upstart/harmony/lib/legos/dealTypes';
import { sendData, getCarInfo } from 'util/amplitude';
import { amplitudeEvents } from 'util/amplitudeEvents';
import './PencilTopSection.scss';
import { UpdateMileageModal } from '../../../components/UpdateMileageModal/UpdateMileageModal';
import CustomerAndCreditApp from './CustomerAndCreditApp/CustomerAndCreditApp';
import SelectedVehicle from './SelectedVehicle/SelectedVehicle';
import AddVehicle from './AddVehicle/AddVehicle';

export interface PencilTopSectionProps {
  car: Car;
  deal: Deal;
  selectedCars: Car[];
  onAdd: () => void;
  onSelect: (car: Car) => void;
  onRemove: (car: Car) => void;
  onMakePrimary: (car: Car) => void;
  onCustomerNameClick: () => void;
  disableAddVehicle: boolean;
}

const PencilTopSection: FunctionComponent<PencilTopSectionProps> = ({
  car,
  deal,
  selectedCars,
  onCustomerNameClick,
  disableAddVehicle,
  onAdd,
  onRemove,
  onMakePrimary,
  onSelect,
}) => {
  const [carToEdit, setCarToEdit] = useState<Car | undefined>(undefined);
  const enableAddVehicle =
    car &&
    selectedCars.length < 3 &&
    !deal.hasActiveChat &&
    (deal?.origin !== Origin.ONLINE || deal?.lastOpenedInStore) &&
    !disableAddVehicle;
  const applicant = (deal || {}).applicant || {};

  let nameLabel = '';
  if (applicant.firstName || applicant.lastName) {
    nameLabel = `${applicant.firstName || ''} ${applicant.lastName ||
      ''}`.trim();
  }

  return (
    <div className="pencil-cars">
      <UpdateMileageModal
        car={carToEdit}
        handleClose={() => {
          setCarToEdit(undefined);
        }}
        sendAmplitudeEvent={event => sendData(event, getCarInfo(carToEdit))}
      />
      <CustomerAndCreditApp
        customerName={nameLabel}
        creditScore={deal?.creditPull?.creditTier?.score}
        dealId={deal.id}
        vin={car?.id}
        onEditCustomer={onCustomerNameClick}
      />
      <div className="selected-vehicles">
        {selectedCars.map((c, idx) => {
          const isPrimary = c.id === deal.car_id;
          const isSelected = c.id === car.id;

          return (
            <SelectedVehicle
              key={c.id || idx}
              id={c.id || idx}
              name={c.name}
              trim={c.trim}
              stock={c.stock}
              mileage={c.mileage}
              isPrimary={isPrimary}
              isSelected={isSelected}
              hasActiveChat={deal.hasActiveChat || false}
              onRemoveVehicle={() => onRemove(c)}
              onEditMileage={() => {
                sendData(
                  amplitudeEvents.DESKING_PENCIL_MILEAGE_CLICK,
                  getCarInfo(c),
                );
                setCarToEdit(c);
                sendData(
                  amplitudeEvents.DESKING_PENCIL_MILEAGE_START,
                  getCarInfo(c),
                );
              }}
              onMakePrimary={() => {
                onMakePrimary(c);
              }}
              onSelectVehicle={() => onSelect(c)}
            />
          );
        })}
      </div>
      {enableAddVehicle && <AddVehicle onAddVehicle={onAdd} />}
    </div>
  );
};

export default PencilTopSection;
